
import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useDarkMode } from '../contexts/DarkModeContext';

interface DarkModeToggleProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function DarkModeToggle({ size = 'md', className = '' }: DarkModeToggleProps) {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  const buttonSizeClasses = {
    sm: 'p-1',
    md: 'p-2',
    lg: 'p-3'
  };

  return (
    <button
      onClick={toggleDarkMode}
      className={`${buttonSizeClasses[size]} rounded-lg transition-colors hover:bg-sand/20 dark:hover:bg-charcoal/20 text-slate dark:text-soft-white ${className}`}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      type="button"
    >
      {isDarkMode ? (
        <Sun className={sizeClasses[size]} />
      ) : (
        <Moon className={sizeClasses[size]} />
      )}
    </button>
  );
}
